<p-dialog modal="true" styleClass="atlas-dialog-s" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>
      {{
      !certification.ProfileCertificationTypeID
      ? ('certification.edit-certification-dialog.add-title' | translate | titlecase)
      : ('certification.edit-certification-dialog.edit-title' | translate | titlecase)
      }}
    </h4>
  </ng-template>
  <div class="mct-flex mct-row mct-grid mct-cols-2-1 mct-gap-27" gdRows="!">
    <div class="mct-flex mct-col">
      <label class="light-text">{{ 'certification.edit-certification-dialog.type' | translate | titlecase }}</label>
      <p-select optionLabel="Name" optionValue="CertificationTypeID" #source
        [(ngModel)]="certification.CertificationTypeID"
        placeholder="{{ 'certification.edit-certification-dialog.select-type' | translate }}"
        [options]="certificationTypes" appendTo="body" [style]="{ width: '100%' }" [required]="true"></p-select>
    </div>
    <div class="mct-flex mct-col">
      <label class="light-text">{{ 'certification.edit-certification-dialog.certification-date' | translate | titlecase
        }}</label>
      <wl-date-selector [(ngModel)]="certification.CertificationDate" appendTo="body"></wl-date-selector>
    </div>
    <div class="mct-flex mct-col">
      <label class="light-text">{{ 'certification.edit-certification-dialog.certification-number' | translate |
        titlecase }}</label>
      <input type="test" [(ngModel)]="certification.CertificationNumber" class="form-control" />
    </div>
    <div class="mct-flex mct-col" *ngIf="certification.ProfileCertificationTypeID">
      <label class="light-text">{{ 'certification.edit-certification-dialog.date-renewed' | translate | titlecase
        }}</label>
      <wl-date-selector [(ngModel)]="certification.ReinstatedDate" appendTo="body"></wl-date-selector>
    </div>
    <div *ngIf="certification.ProfileCertificationTypeID">
      <div [ngClass]="certification.Expired ? 'red-text f-wb' : ''">
        {{
        certification.Expired
        ? ('certification.expired-on' | translate | ucfirst)
        : ('certification.will-expire-on' | translate | ucfirst)
        }}{{ certification.ExpirationDate | date: 'M/d/yyyy' }}
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-justify-end mct-items-stretch">
      <button class="atlas-btn atlas-btn-secondary tall mr-10" (click)="cancel()">{{ 'common.cancel' | translate |
        uppercase
        }}</button>
      <button class="atlas-btn atlas-btn-primary tall" [disabled]="certification.CertificationTypeID == null"
        (click)="save()">
        {{ 'common.save' | translate | uppercase }}
      </button>
    </div>
  </ng-template>
</p-dialog>
